import { createFileRoute } from "@tanstack/react-router";

export interface ExploreAllRouteSearch {
  q?: string;
}

function toExploreAllRouteSearch(raw: unknown): ExploreAllRouteSearch {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) {
    return {};
  }

  const query = (raw as Record<string, unknown>).q;
  if (typeof query !== "string") {
    return {};
  }

  const trimmedQuery = query.trim();
  return trimmedQuery ? { q: trimmedQuery } : {};
}

export const Route = createFileRoute("/_app/explore-all")({
  loader: ({ context }) => {
    void import("~/features/explore/explore-route").then(
      ({ preloadExploreAllRoute }) => {
        void preloadExploreAllRoute(context);
      },
    );
  },
  validateSearch: (raw): ExploreAllRouteSearch =>
    toExploreAllRouteSearch(raw),
});
